import {
  CAR_DATA_MASTER_GET_BRANCHES_BEGIN,
  CAR_DATA_MASTER_GET_BRANCHES_SUCCESS,
  CAR_DATA_MASTER_GET_BRANCHES_FAILURE,
  CAR_DATA_MASTER_GET_BRANCHES_DISMISS_ERROR,
  CAR_DATA_MASTER_GET_BRANCHES_WITH_IMAGE_SUCCESS,
} from './constants';
import axios from "axios";
import { REACT_APP_API_ABM_FW, REACT_APP_IMG } from '../../../common/config';
import { FILES_ENDPOINT } from 'cfgCommon/endpoints'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getBranches(args = {}) {
  return async (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: CAR_DATA_MASTER_GET_BRANCHES_BEGIN,
    });
    try {
      const res = await axios.get(REACT_APP_API_ABM_FW + "/abms/branch_office" + args);
      if (res.data.success) {
        const branches = res.data.data;
        if (branches.length > 0) {
          branches.forEach(branch => {
            branch['logo'] = '';
            branch['logo_mini'] = '';
            branch['company_name'] = branch.Car_lot.Company.name;
            branch['carDealership_name'] = branch.Car_lot.name;
            branch['locationsCount'] = branch.Locations.length;
            if (branch.Locations.length === 0) {
              branch['canDelete'] = true;
            } else {
              branch['canDelete'] = false;
            }
            branch['files'] = {
              'LOGO': [],
              'FIRMA': []
            };
          });
          if (args !== '') {
            
            dispatch({
              type: CAR_DATA_MASTER_GET_BRANCHES_SUCCESS,
              data: branches,
              pagination: res.data.pagination
            });
            // Busca y agrega los link de las imágenes
            let branchesWithImages = await getImages(branches, 'logo')
            branchesWithImages = await getImages(branchesWithImages, 'firma')
            // Dispatch con los link de las imágenes, ejecuta otra acción para recargar el componente visual
            dispatch({
              type: CAR_DATA_MASTER_GET_BRANCHES_WITH_IMAGE_SUCCESS,
              data: branchesWithImages,
              pagination: res.data.pagination
            });
            return res;
            } else {
              dispatch({
                type: CAR_DATA_MASTER_GET_BRANCHES_SUCCESS,
                data: branches,
                pagination: res.data.pagination
              });
              return res;
            }
          } else {
            dispatch({
              type: CAR_DATA_MASTER_GET_BRANCHES_SUCCESS,
              data: [],
              pagination: res.data.pagination
            });
            return res;
          }
        } else {
          dispatch({
            type: CAR_DATA_MASTER_GET_BRANCHES_FAILURE,
            data: [],
          });
          return;
        }
      }
      catch (err) {
        dispatch({
          type: CAR_DATA_MASTER_GET_BRANCHES_FAILURE,
          data: { error: err },
        });
        return err;
      }
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissGetBranchesError() {
  return {
    type: CAR_DATA_MASTER_GET_BRANCHES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CAR_DATA_MASTER_GET_BRANCHES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getBranchesPending: true,
        getBranchesError: null,
      };

    case CAR_DATA_MASTER_GET_BRANCHES_SUCCESS:
      // The request is success
      return {
        ...state,
        getBranchesPending: false,
        isImageLoad: false,
        getBranchesError: null,
        branchListOrigin: [...action.data],
        branchList: [...action.data],
        branchesPagination: { ...action.pagination }
      };

      case CAR_DATA_MASTER_GET_BRANCHES_WITH_IMAGE_SUCCESS:
      return {
        ...state,
        getBranchesPending: false,
        isImageLoad: true,
        getBranchesError: null,
        branchListOrigin: [...action.data],
        branchList: [...action.data],
        branchesPagination: { ...action.pagination }
      };

    case CAR_DATA_MASTER_GET_BRANCHES_FAILURE:
      // The request is failed
      return {
        ...state,
        getBranchesPending: false,
        getBranchesError: action.data.error,
      };

    case CAR_DATA_MASTER_GET_BRANCHES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getBranchesError: null,
      };

    default:
      return state;
  }
}

const getImages = async (branches, imageType) => {
  try {
    const logoList = await Promise.all(branches.map(async (car)=>{
      const urlFirma = FILES_ENDPOINT + '/MAESTRO/' + car.id
      const urlLogo = FILES_ENDPOINT + '/CARDEARLERSHIP_LOGO/' + car.Car_lot.id
      const resLogo = await axios.get(imageType === 'logo' ? urlLogo : urlFirma)
      const item = await (resLogo).data.data
      // toUpperCase y toLowerCase se usan para indicar que el server manda ese Case en cada String a comparar
      if (item.length > 0) {
        car['files'][imageType.toUpperCase()] = item
        car[imageType.toLowerCase()] = REACT_APP_IMG + '/' + item[0].url
        car[`${imageType.toLowerCase()}_mini`] = REACT_APP_IMG + '/' + item[0].mini_url
      }
      return car
    }))
    return logoList
    
  } catch (error) {
      console.log('error: ', error)
    return []
    
  }
}
